export default __webpack_public_path__ + "static/media/page1Bg.5bff6ca9.png";